import React from "react";
import { NewTab, PageTabAdv } from "../../../components";
import InternalSubmission from "./InternalSubmission/InternalSubmission";
import { useModuleAccess } from "../../../hooks";

const InternalSubmissions = () => {
  const InternalSubmissionMenus = [
    {
      title: "Internal Submissions",
      page: <InternalSubmission />,
      type: "main",
      id: "recruitmentinternalsubmissions_internalsubmissions",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: InternalSubmissionMenus,
    parentId: "recruitmentinternalsubmissions",
  });
  return (
    <div className="flex flex-col flex-1 overflow-hidden">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="outlined"
        mode="url"
        tabId="internal-submissions"
      />
    </div>
  );
};

export default InternalSubmissions;
